module.exports = __webpack_public_path__ + "img/mint1-rollover.c189bcaf.png";